module.exports = __webpack_public_path__ + "img/sect4-33.a8fb4862.png";